export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Cloudflare dev tunnels follow the convention cv<N>.certavue.com (e.g. cv1.certavue.com).
// Match strictly on that convention so production hosts on certavue.com (the apex and www.)
// are NOT treated as dev environments — this flag gates Turnstile, rate limiting and which
// web storage auth tokens land in. Keep in sync with CloudflareDevTunnelPattern() in
// Certavue/Extensions/HttpContextExtensions.cs.
export const cloudflareDevTunnelPattern = /^cv\d+\.certavue\.com$/i;

const isCloudflareDevTunnel = cloudflareDevTunnelPattern.test(
    window.location.hostname
);

const isLocalOrDevEnvironment = isLocalhost || isCloudflareDevTunnel;

export default isLocalOrDevEnvironment;
